import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { IPaymentCardType } from '@shared/shared/interfaces/payment-card-types.interface';

@Injectable({ providedIn: 'root' })
export class CardPaymentTypesService {
  constructor(private http: HttpClient) {}

  /**
   * Gets the different available card types for the booking payment form
   */
  public getCardTypes(): Observable<IPaymentCardType[]> {
    return this.http
      .get<{ results: IPaymentCardType[] }>(ApiEndpoint.TRAVEL_BOOKINGS_CARD_TYPES)
      .pipe(map((res) => res.results));
  }
}
